import { initializeSocketClient } from '@corva/ui/clients/subscriptions';

import { connect } from '~/actions/subscriptions';

import { HIDE_LOAD, MAKE_APP_READY, RESET_APP_STATE, SHOW_LOAD } from '~/constants/main';

import * as nativeMessages from '~/utils/nativeMessages';

export function resetAppState() {
  return { type: RESET_APP_STATE };
}

export function makeAppReady() {
  return { type: MAKE_APP_READY };
}

export function showLoad() {
  return { type: SHOW_LOAD };
}

export function hideLoad() {
  return { type: HIDE_LOAD };
}

export function start() {
  return dispatch => {
    connect(dispatch);
    initializeSocketClient();
    nativeMessages.notifyPageLoaded();
  };
}
